export default __webpack_public_path__ + "static/media/Dashboard.07b37d60.svg";